(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["HP-sec-01"] && !Shopify.designMode) return;
  try {
    
  // TASK 5 (Φ4): lazy-init των autoplay MP4 (data-lazy-video) — src μπαίνει όταν
  // το βίντεο πλησιάζει το viewport· fallback χωρίς IO = άμεση φόρτωση.
  (function () {
    var vids = document.querySelectorAll('video[data-lazy-video]');
    if (!vids.length) return;
    function hydrate(v) {
      v.querySelectorAll('source[data-src]').forEach(function (s) {
        s.src = s.getAttribute('data-src');
        s.removeAttribute('data-src');
      });
      v.load();
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          hydrate(en.target);
          io.unobserve(en.target);
        });
      }, { rootMargin: '800px 0px' });
      vids.forEach(function (v) { io.observe(v); });
    } else {
      vids.forEach(hydrate);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    // View toggle (client-only, localStorage — parity με live)
    var grid = document.querySelector('[data-product-grid]');
    var toggles = document.querySelectorAll('[data-view-toggle] button');
    function setView(v) {
      grid.setAttribute('data-cols', v);
      toggles.forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-view') === v);
      });
    }
    if (grid && toggles.length) {
      var saved = localStorage.getItem('collectionView');
      if (saved) setView(saved);
      toggles.forEach(function (b) {
        b.addEventListener('click', function () {
          setView(b.getAttribute('data-view'));
          localStorage.setItem('collectionView', b.getAttribute('data-view'));
        });
      });
    }

    // m2: Off-canvas φίλτρα → ΜΕΤΑΦΕΡΘΗΚΕ στο collection-filters.js (TASK 62στ:
    // single-source — το asset φορτώνει και στο /search όπου το section-JS όχι)

    // Προϊόντα ανά σελίδα → cart attribute (ΙΔΙΟΣ μηχανισμός με live) + reload
    var perPage = document.querySelector('[data-per-page]');
    if (perPage) {
      perPage.addEventListener('change', function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { pagination: perPage.value } })
        }).then(function () { window.location.reload(); });
      });
    }

    // Ταξινόμηση → ?sort_by= (ίδιο param με live)
    var sortBy = document.querySelector('[data-sort-by]');
    if (sortBy) {
      sortBy.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortBy.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    // Description read-more
    var more = document.querySelector('[data-desc-more]');
    var less = document.querySelector('[data-desc-less]');
    if (more && less) {
      more.addEventListener('click', function () {
        document.querySelector('[data-desc-teaser]').hidden = true;
        document.querySelector('[data-desc-full]').hidden = false;
      });
      less.addEventListener('click', function () {
        document.querySelector('[data-desc-teaser]').hidden = false;
        document.querySelector('[data-desc-full]').hidden = true;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customers"]) return;
  try {
    
  (function () {
    var show = document.querySelector('[data-show-recover]');
    var hide = document.querySelector('[data-hide-recover]');
    var panel = document.querySelector('[data-recover]');
    if (show && panel) {
      show.addEventListener('click', function (e) { e.preventDefault(); panel.hidden = false; });
      if (window.location.hash === '#recover') panel.hidden = false; // live deep-link parity
    }
    if (hide && panel) hide.addEventListener('click', function (e) { e.preventDefault(); panel.hidden = true; });
    // προεπιλογή Ελλάδα στο country select
    var country = document.querySelector('select[name="address[country]"]');
    if (country && !country.value) country.value = country.getAttribute('data-default') || 'Greece';
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-3647"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // single-open accordion (live parity)
    var wrap = document.querySelector('[data-faq]');
    if (!wrap) return;
    wrap.addEventListener('toggle', function (e) {
      if (e.target.tagName === 'DETAILS' && e.target.open) {
        wrap.querySelectorAll('details[open]').forEach(function (d) {
          if (d !== e.target) d.open = false;
        });
      }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-footer-toggle]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (window.innerWidth > 767) return;
        t.parentElement.classList.toggle('is-open');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    // Mobile menu drawer
    var drawer = document.querySelector('[data-mobile-menu]');
    var openBtn = document.querySelector('[data-mobile-menu-open]');
    if (drawer && openBtn) {
      openBtn.addEventListener('click', function () {
        drawer.showModal();
        openBtn.setAttribute('aria-expanded', 'true');
      });
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer) drawer.close();
      });
      var closeBtn2 = drawer.querySelector('[data-mobile-menu-close]');
      if (closeBtn2) closeBtn2.addEventListener('click', function () { drawer.close(); });
      drawer.addEventListener('close', function () {
        openBtn.setAttribute('aria-expanded', 'false');
      });
    }

    // TASK 21: full-screen search overlay — triggers: desktop μπάρα (focus) +
    // mobile icon (click, href = no-JS fallback). Predictive = κληρονομείται
    // (το overlay έχει δικό του [data-search-box], quickview.js autocomplete).
    var searchOverlay = document.querySelector('[data-search-overlay]');
    if (searchOverlay) {
      var overlayInput = searchOverlay.querySelector('[data-search-overlay-input]');
      var openSearchOverlay = function () {
        if (searchOverlay.open) return;
        searchOverlay.showModal();
        overlayInput.focus();
      };
      // Φ4 owner-ruling: μοναδικός trigger = το 🔍 icon (η inline μπάρα καταργήθηκε
      // — μαζί της έφυγε και το anti-reopen-loop plumbing που υπήρχε μόνο γι' αυτήν·
      // στο icon το focus-restore μετά το close είναι ακίνδυνο)
      var searchIconLink = document.querySelector('.header-actions__search-icon');
      if (searchIconLink) {
        searchIconLink.addEventListener('click', function (e) {
          e.preventDefault();
          openSearchOverlay();
        });
      }
      var overlayClose = searchOverlay.querySelector('[data-search-overlay-close]');
      if (overlayClose) {
        overlayClose.addEventListener('click', function () { searchOverlay.close(); });
      }

      // ---- TASK 21γ: panel δεδομένα (predictive API: collections+queries+products)
      var spBody = searchOverlay.querySelector('[data-sp-body]');
      var spSugg = searchOverlay.querySelector('[data-sp-suggestions]');
      var spSuggHead = searchOverlay.querySelector('[data-sp-sugg-head]');
      var spProds = searchOverlay.querySelector('[data-sp-products]');
      var spNone = searchOverlay.querySelector('[data-sp-none]');
      var spNote = searchOverlay.querySelector('[data-sp-skunote]');
      var spFor = searchOverlay.querySelector('[data-sp-searchfor]');
      var spClear = searchOverlay.querySelector('[data-sp-clear]');
      var spTimer = null;
      var spAbort = null;

      function grNorm(s) {
        // αναζήτηση χωρίς τόνους/πεζά (bold-match των Προτάσεων)
        return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ς/g, 'σ');
      }
      function grUpper(s) {
        // ελληνικά κεφαλαία ΧΩΡΙΣ τόνους (τυπογραφικά σωστό — design κανόνας)
        return s.normalize('NFD').replace(/[̀́͂ͅ]/g, '').normalize('NFC').toUpperCase();
      }
      function escHtml(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
      function boldMatch(label, raw) {
        var up = grUpper(label);
        var i = grNorm(up).indexOf(grNorm(raw));
        if (i === -1 || !raw) return escHtml(up);
        return escHtml(up.slice(0, i)) + '<b>' + escHtml(up.slice(i, i + raw.length)) + '</b>' + escHtml(up.slice(i + raw.length));
      }
      function spRender(q) {
        clearTimeout(spTimer);
        var raw = q.trim();
        spClear.hidden = raw === '';
        if (raw.length < 2) { spBody.hidden = true; return; }
        spTimer = setTimeout(function () {
          if (spAbort) spAbort.abort();
          spAbort = ('AbortController' in window) ? new AbortController() : null;
          var spForm = document.getElementById('SearchPanelForm');
          // TASK 62: SearchIntel.resolve = raw πρώτα (brands/SKU), αλλιώς
          // Greeklish→ελληνικά variants μέχρι το πρώτο με αποτελέσματα
          var lookup = window.SearchIntel
            ? window.SearchIntel.resolve(raw, spAbort && spAbort.signal)
            : fetch('/search/suggest.json?q=' + encodeURIComponent(raw) +
                '&resources[type]=product,collection,query&resources[limit]=4&resources[options][unavailable_products]=hide',
                spAbort ? { signal: spAbort.signal } : undefined)
                .then(function (r) { return r.json(); })
                .then(function (data) {
                  return { query: raw, results: (data && data.resources && data.resources.results) || {} };
                });
          lookup
            .then(function (out) {
              var res = out.results || {};
              var effective = out.query || raw;
              // το submit θα στείλει το λυμένο ελληνικό query — ΜΟΝΟ αν αντιστοιχεί
              // σε ό,τι είναι ΤΩΡΑ στο πεδίο (guard για γρήγορη πληκτρολόγηση)·
              // αν το query = κατηγορία → effectiveUrl = η συλλογή (owner-αρχή)
              if (spForm) {
                spForm.dataset.effectiveQ = effective;
                spForm.dataset.effectiveFor = raw;
                if (out.collectionUrl) spForm.dataset.effectiveUrl = out.collectionUrl;
                else delete spForm.dataset.effectiveUrl;
              }
              function renderProds(list) {
                spProds.innerHTML = list.map(function (p) {
                  var img = p.featured_image && p.featured_image.url
                    ? '<img src="' + escHtml(p.featured_image.url + (p.featured_image.url.indexOf('?') === -1 ? '?' : '&') + 'width=420') + '" alt="" loading="lazy" width="420" height="420">'
                    : '';
                  return '<a class="sp-card" href="' + escHtml(p.url) + '">' +
                    '<span class="sp-card__media">' + img + '</span>' +
                    '<span class="sp-card__title">' + escHtml(p.title) + '</span>' +
                    '<span class="sp-card__price">€' + escHtml(String(p.price)) + '</span></a>';
                }).join('');
              }

              // TASK 62γ (owner): SKU-mode — ΧΩΡΙΣ fuzzy. Ακριβής κωδικός →
              // ΜΟΝΟ αυτός· ανύπαρκτος → ρητή ένδειξη + παρόμοιοι κωδικοί.
              if (window.SearchIntel && window.SearchIntel.looksLikeSku(raw)) {
                spSuggHead.hidden = true;
                spSugg.innerHTML = '';
                spFor.textContent = 'ΑΝΑΖΗΤΗΣΗ ΓΙΑ ' + raw.toUpperCase();
                window.SearchIntel.verifyExactSku(raw, res.products || []).then(function (exact) {
                  if (exact.length) {
                    spNote.hidden = true;
                    renderProds(exact.slice(0, 3));
                    spNone.hidden = true;
                    spBody.hidden = false;
                  } else {
                    window.SearchIntel.skuSimilar(raw, spAbort && spAbort.signal).then(function (sim) {
                      var simProds = (sim && sim.products) ? sim.products.slice(0, 3) : [];
                      spNote.textContent = simProds.length
                        ? 'Ο κωδικός «' + raw.toUpperCase() + '» δεν υπάρχει — παρόμοιοι κωδικοί:'
                        : 'Ο κωδικός «' + raw.toUpperCase() + '» δεν υπάρχει.';
                      spNote.hidden = false;
                      renderProds(simProds);
                      spNone.hidden = true;
                      spBody.hidden = false;
                    }).catch(function () {});
                  }
                }).catch(function () {});
                return;
              }
              spNote.hidden = true;

              var colls = res.collections || [];
              var queries = res.queries || [];
              var prods = (res.products || []).slice(0, 3);

              // Σ07-12 owner-bug: το predictive προτείνει και ΑΔΕΙΕΣ συλλογές
              // (π.χ. «Βραχιόλια Jcou» με 0 προϊόντα) → φίλτρο με cached σύνολο
              // άδειων handles (sessionStorage, 1 φόρτωση/session, fail-open).
              if (window.__spEmptyColls === undefined) {
                window.__spEmptyColls = null; // loading
                try {
                  var cached = sessionStorage.getItem('sp-empty-colls');
                  if (cached) { window.__spEmptyColls = JSON.parse(cached); }
                } catch (e) { /* fail-open */ }
                if (!window.__spEmptyColls) {
                  (function loadPage(page, acc) {
                    fetch('/collections.json?limit=250&page=' + page)
                      .then(function (r) { return r.json(); })
                      .then(function (j) {
                        var cs = (j && j.collections) || [];
                        cs.forEach(function (c) { if (!(c.products_count > 0)) acc.push(c.handle); });
                        if (cs.length === 250 && page < 5) { loadPage(page + 1, acc); }
                        else {
                          window.__spEmptyColls = acc;
                          try { sessionStorage.setItem('sp-empty-colls', JSON.stringify(acc)); } catch (e) {}
                          /* Σ07-12 option-β (owner): μόλις ετοιμαστεί το φίλτρο, ξανατρέχει
                             η τρέχουσα αναζήτηση → οι άδειες εξαφανίζονται επιτόπου
                             (η 1η προβολή δεν καθυστέρησε ποτέ) */
                          if (acc.length && overlayInput && overlayInput.value.trim()) {
                            overlayInput.dispatchEvent(new Event('input', { bubbles: true }));
                          }
                        }
                      }).catch(function () { window.__spEmptyColls = []; });
                  })(1, []);
                }
              }
              /* + Σ07-12: κρυφές συλλογές (influencer, window.__hiddenCollections) ΕΞΩ */
              var spBlocked = (window.__spEmptyColls || []).concat(window.__hiddenCollections || []);
              if (spBlocked.length) {
                colls = colls.filter(function (c) {
                  var h = ((c.url || '').split('?')[0].split('/collections/')[1] || '').replace(/\/$/, '');
                  try { h = decodeURIComponent(h); } catch (e) {}
                  return spBlocked.indexOf(h) === -1;
                });
              }

              // Προτάσεις: συλλογές πρώτα, μετά query-completions — σύνολο 4
              var items = colls.map(function (c) { return { label: c.title, url: c.url }; });
              queries.forEach(function (que) {
                if (items.length < 4) items.push({ label: que.text, url: '/search?q=' + encodeURIComponent(que.text) + '*&type=product' });
              });
              items = items.slice(0, 4);
              spSugg.innerHTML = items.map(function (it) {
                return '<li><a href="' + escHtml(it.url) + '">' + boldMatch(it.label, effective) + '</a></li>';
              }).join('');
              spSuggHead.hidden = items.length === 0;

              spFor.textContent = 'ΑΝΑΖΗΤΗΣΗ ΓΙΑ ' + grUpper(effective);

              renderProds(prods);
              spNone.hidden = prods.length !== 0;
              spBody.hidden = false;
            })
            .catch(function () { /* aborted ή σφάλμα — κράτα την τρέχουσα κατάσταση */ });
        }, 250);
      }
      overlayInput.addEventListener('input', function () { spRender(overlayInput.value); });
      spClear.addEventListener('click', function () {
        overlayInput.value = '';
        overlayInput.focus();
        spClear.hidden = true;
        spBody.hidden = true;
      });

      // Owner-bug Σ07-10 (γρήγορο Enter): αν το submit φύγει ΠΡΙΝ προλάβει το
      // resolve (debounce 250ms + fetch), θα έστελνε το ωμό greeklish («kolie*»
      // → 11 άσχετα). Interception: κράτα το submit, λύσε, μετά υπέβαλε.
      var spFormEl = document.getElementById('SearchPanelForm');
      if (spFormEl) {
        spFormEl.addEventListener('submit', function (e) {
          var val = overlayInput.value.trim();
          if (!window.SearchIntel || !val) return;
          if (window.SearchIntel.looksLikeSku(val)) return; // SKU: κατευθείαν /search
          if (spFormEl.dataset.effectiveFor === val) {
            // ήδη λυμένο: κατηγορία → συλλογή· αλλιώς το global hook αναλαμβάνει
            if (spFormEl.dataset.effectiveUrl) {
              e.preventDefault();
              location.href = spFormEl.dataset.effectiveUrl;
            }
            return;
          }
          // άλυτο ακόμα (γρήγορο Enter, ελληνικά ή greeklish) → λύσε πρώτα
          e.preventDefault();
          window.SearchIntel.resolve(val).then(function (out) {
            if (out.collectionUrl) { location.href = out.collectionUrl; return; }
            // TASK 62η: ΣΚΕΤΟ query (ακριβές ταίριασμα)· η /search αυτο-αναβαθμίζει
            // σε wildcard μόνο αν τα αποτελέσματα βγουν φτωχά
            location.href = '/search?type=product&q=' + encodeURIComponent(out.query || val);
          }).catch(function () {
            location.href = '/search?type=product&q=' + encodeURIComponent(val);
          });
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-hrev]');
    if (!root) return;
    var nodes = root.querySelectorAll('[data-hrev-node]');
    var items = root.querySelectorAll('[data-hrev-item]');
    if (!nodes.length || nodes.length !== items.length) return;
    var idx = 0;
    var timer = null;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(i) {
      idx = (i + items.length) % items.length;
      nodes.forEach(function (n, j) { n.classList.toggle('on', j === idx); });
      items.forEach(function (it, j) { it.classList.toggle('on', j === idx); });
    }
    function start() {
      if (reduced || timer) return;
      timer = setInterval(function () { show(idx + 1); }, 7000);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    nodes.forEach(function (n, j) {
      n.addEventListener('click', function () { show(j); stop(); start(); });
    });

    // αυτόματη εναλλαγή ΜΟΝΟ όσο το section είναι ορατό
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { threshold: 0.25 }).observe(root);
    } else {
      start();
    }
  })();

  // Ivory Band mobile: dots ↔ σελίδες (1 κριτική/σελίδα)
  (function () {
    var cols = document.querySelector('.hrev4__cols');
    var dots = document.querySelectorAll('[data-hrev4-dot]');
    if (!cols || !dots.length) return;
    cols.addEventListener('scroll', function () {
      var p = Math.round(cols.scrollLeft / cols.clientWidth);
      dots.forEach(function (d, j) { d.classList.toggle('on', j === p); });
    }, { passive: true });
    dots.forEach(function (d, j) {
      d.addEventListener('click', function () {
        cols.scrollTo({ left: j * cols.clientWidth, behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-prec]');
    if (!el) return;
    function wireArrows() {
      var row = el.querySelector('[data-prec-row]');
      if (!row) return;
      el.addEventListener('click', function (e) {
        if (e.target.closest('[data-prec-prev]')) row.scrollBy({ left: -row.clientWidth, behavior: 'smooth' });
        if (e.target.closest('[data-prec-next]')) row.scrollBy({ left: row.clientWidth, behavior: 'smooth' });
      });
    }
    if (el.querySelector('.prec__row')) { wireArrows(); return; } // ήδη rendered
    var url = '/recommendations/products?section_id=' + el.getAttribute('data-section-id') +
      '&product_id=' + el.getAttribute('data-product-id') + '&limit=8';
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-prec]');
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; wireArrows(); }
      })
      .catch(function () { /* σιωπηλά — προαιρετικό block */ });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // TASK 64: μετά την υποβολή το return_to φέρνει ?bis=ok (ή customer_posted=true
  // fallback) → δείξε το success ΣΤΟ ΙΔΙΟ σημείο (θέση χαράγματος), κρύψε τα πεδία
  (function () {
    var ok = document.querySelector('[data-bis-ok]');
    if (!ok) return;
    var q = new URLSearchParams(location.search);
    if (q.get('bis') === 'ok' || q.get('customer_posted') === 'true') {
      ok.hidden = false;
      var f = document.querySelector('[data-bis-fields]');
      if (f) f.hidden = true;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"]) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-rv]');
    if (!el) return;
    var KEY = 'recently-viewed';
    var current = el.getAttribute('data-current-handle');

    function read() {
      try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; }
      catch (e) { return []; }
    }
    var list = read();
    // TASK 62β: κρυφά βοηθητικά προϊόντα (εγγύηση) — ούτε render ούτε καταγραφή
    var excluded = window.__searchExcluded || [];
    list = list.filter(function (h) { return excluded.indexOf(h) === -1; });

    // render όσα ΔΕΝ είναι το τρέχον
    var show = list.filter(function (h) { return h !== current; }).slice(0, 8);
    if (show.length) {
      el.hidden = false;
      var row = el.querySelector('[data-rv-row]');
      show.forEach(function (handle) {
        var item = document.createElement('div');
        item.className = 'rv__item';
        item.hidden = true;
        row.appendChild(item);
        fetch('/products/' + handle + '.js')
          .then(function (r) { if (!r.ok) throw new Error('gone'); return r.json(); })
          .then(function (prod) {
            var img = prod.featured_image ? prod.featured_image + (prod.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=400' : '';
            var n = (prod.price / 100).toFixed(2).split('.');
            var money = '€' + n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1];
            item.innerHTML = '<a href="' + prod.url + '">' + (img ? '<img loading="lazy" src="' + img + '" alt="">' : '') + '</a>' +
              '<a class="rv__item-title" href="' + prod.url + '">' + prod.title + '</a>' +
              '<div class="rv__item-price">' + money + '</div>';
            item.hidden = false;
          })
          .catch(function () { item.remove(); });
      });
    }

    // καταχώρησε το τρέχον (μετά το render — να μη δείχνει τον εαυτό του)·
    // TASK 62β: τα κρυφά βοηθητικά (εγγύηση) δεν καταγράφονται ποτέ
    if (excluded.indexOf(current) === -1) {
      var next = [current].concat(list.filter(function (h) { return h !== current; })).slice(0, 10);
      try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) { /* private mode */ }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-page"]) return;
  try {
    
  (function () {
    var body = document.querySelector('[data-wishlist-body]');
    if (!body) return;
    var table = document.querySelector('[data-wishlist-table]');

    function money(cents) {
      var n = (cents / 100).toFixed(2).split('.');
      return '€' + n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1];
    }

    function render() {
      var items = (window.ThemeWishlist && window.ThemeWishlist.read()) || [];
      var empty = document.querySelector('[data-wishlist-empty]');
      var share = document.querySelector('[data-wishlist-share]');
      body.innerHTML = '';
      if (!items.length) {
        table.hidden = true;
        empty.hidden = false;
        share.hidden = true;
        return;
      }
      table.hidden = false;
      empty.hidden = true;
      share.hidden = false;
      var mailto = document.querySelector('[data-wishlist-mailto]');
      if (mailto) {
        var urls = items.map(function (h) { return location.origin + '/products/' + h; }).join('%0D%0A');
        mailto.href = 'mailto:?subject=' + encodeURIComponent('Η wishlist μου — ' + location.hostname) + '&body=' + urls;
      }
      // placeholder rows με τη σειρά του χρήστη — γεμίζουν όταν έρθει το καθένα
      items.forEach(function (handle) {
        var tr = document.createElement('tr');
        tr.hidden = true;
        body.appendChild(tr);
        fetch('/products/' + handle + '.js')
          .then(function (r) { if (!r.ok) throw new Error('gone'); return r.json(); })
          .then(function (prod) {
            var img = '';
            if (prod.featured_image) {
              img = prod.featured_image + (prod.featured_image.indexOf('?') === -1 ? '?' : '&') + 'width=170';
            }
            tr.innerHTML =
              '<td><a href="' + prod.url + '">' + (img ? '<img loading="lazy" src="' + img + '" alt="">' : '') + '</a></td>' +
              '<td><a class="wishlist-table__title-link" href="' + prod.url + '">' + prod.title + '</a></td>' +
              '<td class="wishlist-table__price">' + money(prod.price) + '</td>' +
              '<td class="wishlist-table__add"><a class="wishlist-table__select" href="' + prod.url + '">Επιλέξτε</a></td>' +
              '<td class="wishlist-table__remove-td"><button type="button" class="wishlist-table__remove" aria-label="Αφαίρεση" data-wl-remove="' + handle + '">✕</button></td>';
            tr.hidden = false;
          })
          .catch(function () { tr.remove(); /* προϊόν αφαιρέθηκε από τον κατάλογο */ });
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wl-remove]');
      if (!btn) return;
      window.ThemeWishlist.toggle(btn.getAttribute('data-wl-remove'));
      render();
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
    else render();
  })();

  } catch(e) { console.error(e); }
})();
})();
